import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/volumes';
export function Bonuses() {
  return <section aria-label="Boni" className="border-y border-grape/10 bg-white/70" data-id="element-16" data-mp="plsj010puu7n">
      <div className="mx-auto max-w-5xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "22px"
    }} data-id="element-17" data-mp="authtb27n7y3">
        <h2 className="text-center font-display text-2xl font-black text-grape sm:text-4xl" data-id="element-18" data-mp="fs3bj2wmu5rq">
          🎁 5 Kostenlose Boni inklusive
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-sm text-plum/60" data-id="element-19" data-mp="5w8olvldloj5">
          Zusätzlich zum Haupt-E-Book (6 Bände) erhalten Sie diese Geschenke — ohne Aufpreis.
        </p>

        <div className="mt-12 grid gap-5 sm:grid-cols-2" data-id="element-20" data-mp="3t06egnsvdz6b">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative grid grid-cols-[5.5rem_1fr] items-start gap-x-4 gap-y-3 rounded-2xl border border-grape/20 bg-cream p-4 sm:grid-cols-[6.5rem_1fr]" data-id="element-21" data-mp="1ma8lsysu702p" data-mpi={i}>
              <div className="flex flex-col items-start gap-1" style={{
            paddingTop: "12px",
            width: "95px",
            height: "57px"
          }} data-id="element-22" data-mp="3r5gihsmxey9v">
                <span className="inline-flex items-center gap-1 rounded-md bg-grape px-2 py-0.5 text-[10px] font-black uppercase tracking-wide text-white" style={{
              fontSize: "14px"
            }} data-id="element-23" data-mp="3n5y6jmd31xj6">
                  <GiftIcon className="h-2.5 w-2.5" aria-hidden="true" data-id="element-24" data-mp="2uibvxu5ftsmt" /> Boni {b.n}
                </span>
                <span className="text-[11px] font-bold leading-tight" data-id="element-25" data-mp="38hjuqlxouyqh">
                  <span className="text-plum/40 line-through" data-id="element-26" data-mp="33ge3ytnl9ljl">{b.price}</span>{' '}
                  <span className="uppercase text-blush-deep" data-id="element-27" data-mp="np8c8kd7thku">Kostenlose</span>
                </span>
              </div>
              <h3 className="self-center text-[15px] font-bold leading-snug text-plum" data-id="element-28" data-mp="iq56sytbp9cc">{b.title}</h3>

              <img src={b.cover} alt={`${b.title} Cover`} width={1024} height={1536} loading="lazy" decoding="async" sizes="104px" className="h-auto w-full rounded-lg object-contain drop-shadow-[0_10px_18px_rgba(43,29,24,0.25)]" data-id="element-29" data-mp="3ciemd4oadwzm" />
              <p className="text-[13px] leading-relaxed text-plum/65" data-id="element-30" data-mp="3lhryk53sozo1">{b.desc}</p>
            </motion.div>)}
        </div>

        <div className="mt-10 rounded-2xl border border-blush/40 bg-blush-soft p-6 text-center" style={{
        paddingTop: "11px",
        paddingBottom: "11px"
      }} data-id="element-31" data-mp="2tsoryiofrd88">
          <p className="text-base font-bold text-plum sm:text-lg" data-id="element-32" data-mp="2xua0jrtxt5cm">
            💰 Gesamtwert aller Boni: <span className="text-plum/50 line-through" data-id="element-33" data-mp="32rsclr3940ou">$195</span>{' '}
            <span className="text-[15px] text-blush-deep" data-id="element-34" data-mp="37kv7q3nofi75">
              HEUTE KOSTENLOSE MIT DER REHA-CODE 360°
            </span>
          </p>
        </div>
      </div>
    </section>;
}